// extracted by mini-css-extract-plugin
module.exports = {"mobile-only":"styles_mobile-only__yhVnT","desktop-only":"styles_desktop-only__5Fb8Q","skeleton-animation":"styles_skeleton-animation__9AnLg"};